export default __webpack_public_path__ + "static/media/exbeach.21d02a42.jpg";